import { render, staticRenderFns } from "./WpQuickTool.vue?vue&type=template&id=5f4d3ad4&"
import script from "./WpQuickTool.vue?vue&type=script&lang=js&"
export * from "./WpQuickTool.vue?vue&type=script&lang=js&"
import style0 from "./WpQuickTool.vue?vue&type=style&index=0&id=5f4d3ad4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports